import { HYDRATE } from "next-redux-wrapper";
import { ActionsLoginPopup } from "./actions";

const initialState = { data: { showModalVerifyEmail: false } };

function storeModalVerify(state = initialState, action) {

	switch (action.type) {

	case HYDRATE: {

		return { ...state, ...action.payload.storeModalVerify };

	}
	case ActionsLoginPopup.SHOW_MODAL_VERIFY_EMAIL:
		return { ...state, data: { showModalVerifyEmail: action?.showModalVerifyEmail } };
	default: {

		return {
			...state,
		};

	}

	}

}

export default storeModalVerify;
